import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, HeartPulse, Shield, FileText } from 'lucide-react';
export function WhatsIncluded() {
  const items = [{
    icon: Calendar,
    title: 'Plan de 30 días paso a paso',
    description: 'Con metas pequeñas, checklist diario y revisiones semanales para que avances sin agobiarte.'
  }, {
    icon: HeartPulse,
    title: 'Kit de primeros auxilios para crisis',
    description: 'Cuando la ansiedad sube fuerte, no improvisas: aplicas. Incluye técnicas de respiración, grounding 5-4-3-2-1, urge surfing y frases de emergencia.'
  }, {
    icon: Shield,
    title: 'Prevención de recaídas',
    description: "Modelo ABC (TCC) para romper el ciclo mental, herramientas ACT para 'despegarte' de pensamientos y plan de recaída sin culpa."
  }, {
    icon: FileText,
    title: 'Anexos imprimibles',
    description: 'Registro diario, plan de crisis, tabla ABC, jerarquía de exposición y lista de actividades sustitutas.'
  }];
  return <section className="py-24 md:py-32 px-6 bg-[#FAF8F5]" data-id="element-162">
      <div className="max-w-4xl mx-auto" data-id="element-163">
        <h2 className="text-3xl md:text-4xl font-serif text-[#2D2A26] text-center mb-14" data-id="element-164">
          ¿Qué incluye exactamente?
        </h2>

        <div className="grid gap-6" data-id="element-165">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-[#E5E0D8] flex gap-6 items-start" data-id="element-166">
              <div className="w-14 h-14 bg-[#C4956A]/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-167">
                <item.icon className="w-7 h-7 text-[#C4956A]" data-id="element-168" />
              </div>
              <div data-id="element-169">
                <h3 className="text-xl font-serif text-[#2D2A26] mb-2" data-id="element-170">
                  {item.title}
                </h3>
                <p className="text-[#4D4A46] leading-relaxed text-base" data-id="element-171">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}